"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateTicketBrandings = void 0;
var CreateTicketBrandings;
(function (CreateTicketBrandings) {
    CreateTicketBrandings["COPETENCE"] = "cp";
    CreateTicketBrandings["BLANK"] = "b";
    CreateTicketBrandings["LINDE"] = "l";
    CreateTicketBrandings["LEASEFORCE"] = "lf";
    CreateTicketBrandings["JRC"] = "jrc";
})(CreateTicketBrandings = exports.CreateTicketBrandings || (exports.CreateTicketBrandings = {}));
